<agr-page-detail
  [pageTitle]="pageTitle$ | async"
  data-test="delivery-item__page-detail"
  (backAction)="back()"
>
  <div class="delivery-item spacing--padding-all spacing--margin-all" data-test="delivery-item">
    <form (submit)="save()" [formGroup]="deliveryGroup">
      <div class="flex--column">
        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'delivery-item.delivery-date' | translate }}</mat-label>
          <input
            matInput
            formControlName="deliveryDate"
            [matDatepicker]="deliveryDatePicker"
            placeholder="{{ 'delivery-item.delivery-date' | translate }}"
            [value]=""
            [max]="maxDeliveryDate$ | async"
            data-test="delivery-item__delivery-date"
          />
          <mat-datepicker-toggle matIconSuffix [for]="deliveryDatePicker"></mat-datepicker-toggle>
          <mat-datepicker touchUi #deliveryDatePicker></mat-datepicker>
          <mat-error *ngIf="deliveryGroup.controls.deliveryDate.invalid">
            {{ 'delivery-item.error-delivery-date' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'delivery-item.product-title' | translate }}</mat-label>
          <input
            matInput
            formControlName="productTitle"
            placeholder="{{ 'delivery-item.product-title' | translate }}"
            data-test="delivery-item__product-title"
          />
          <mat-error *ngIf="deliveryGroup.controls.productTitle.invalid">
            {{ 'delivery-item.error-product-title' | translate }}</mat-error
          >
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'delivery-item.external-product-id' | translate }}</mat-label>
          <input
            matInput
            formControlName="externalProductId"
            placeholder="{{ 'delivery-item.external-product-id' | translate }}"
            data-test="delivery-item__external-product-id"
          />
        </mat-form-field>

        <mat-form-field *ngIf="cycleId" class="flex__child--auto">
          <mat-select
            [hideSingleSelectionIndicator]="true"
            formControlName="barnId"
            placeholder="{{ 'delivery-item.barn' | translate }}"
            data-test="delivery-item__barn-selector"
            (ngModelChange)="changeBarnSelection($event)"
          >
            <mat-option [value]=""> </mat-option>
            <mat-option *ngFor="let barn of barnOptions$ | async" [value]="barn.id">
              {{ barn.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-slide-toggle
          [hideIcon]="true"
          formControlName="productType"
          color="primary"
          data-test="delivery-item__product-type"
          class="delivery-item__product-type spacing--margin-bottom spacing--padding-vertical"
        >
          {{ 'delivery-item.product-type-multiple' | translate }}
        </mat-slide-toggle>

        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'delivery-item.units-delivered' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            [enableStepArrows]="false"
            data-test="delivery-item__units-delivered"
            formControlName="unitsDelivered"
            placeholder="{{ 'delivery-item.units-delivered' | translate }}"
          />
          <span matTextSuffix class="form-field-suffix">{{ unitVolumeType }}</span>
          <mat-error *ngIf="deliveryGroup.controls.unitsDelivered.errors?.required">
            {{ 'delivery-item.error-units-delivered' | translate }}</mat-error
          >
          <mat-error
            *ngIf="
              !deliveryGroup.controls.unitsDelivered.errors?.required &&
              deliveryGroup.controls.unitsDelivered.errors?.notEnough
            "
          >
            {{ 'delivery-item.error-units-delivered-not-enough' | translate }}
            {{ deliveryGroup.controls.unitsDelivered.errors?.notEnough }}
          </mat-error>
        </mat-form-field>

        <mat-slide-toggle
          [hideIcon]="true"
          data-test="manual-delivery__toggleAmounts"
          color="primary"
          class="text--small spacing--padding-right spacing--margin-bottom"
          labelPosition="before"
          formControlName="amounts"
        >
          {{ 'enter-amounts' | translate }}
        </mat-slide-toggle>
        <mat-form-field class="flex__child--auto" *ngIf="deliveryGroup.controls.amounts.value">
          <mat-label>{{ 'delivery-item.price' | translate }}</mat-label>
          <span matTextPrefix agrNumber class="spacing--padding-half-right">{{
            currency | agrCurrencySymbol
          }}</span>
          <input
            matInput
            agrNumber
            [step]="0.0001"
            [enableStepArrows]="false"
            data-test="delivery-item__price"
            formControlName="price"
            placeholder="{{ 'delivery-item.price' | translate }}"
          />
          <mat-error *ngIf="deliveryGroup.controls.price.invalid">
            {{ 'delivery-item.error-price' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="flex__child--auto" *ngIf="deliveryGroup.controls.amounts.value">
          <mat-label>{{ 'delivery-item.price-per-100kg' | translate }}</mat-label>
          <span matTextPrefix agrNumber class="spacing--padding-half-right">{{
            currency | agrCurrencySymbol
          }}</span>
          <input
            matInput
            agrNumber
            [step]="0.0001"
            [enableStepArrows]="false"
            data-test="delivery-item__price-per-100kg"
            formControlName="pricePer100kg"
            placeholder="{{ 'delivery-item.price-per-100kg' | translate }}"
          />
          <mat-error *ngIf="deliveryGroup.controls.pricePer100kg.invalid">
            {{ 'delivery-item.error-price-per-100kg' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-slide-toggle
          [hideIcon]="true"
          style="padding-right: 30px"
          data-test="delivery-item__show-in-final-setup-toggle"
          color="primary"
          labelPosition="before"
          formControlName="showInFinalSetup"
          (click)="$event.stopPropagation()"
          *ngIf="isFinalSetup$ | async"
          class="spacing--margin-bottom"
        >
          <span class="text--small">{{
            'delivery-overview.table.showInFinalSetup' | translate
          }}</span>
        </mat-slide-toggle>

        <mat-form-field
          class="flex__child--auto"
          [ngClass]="{ 'spacing--margin-top': deliveryGroup.controls.amounts.value === false }"
          *ngIf="isFinalSetup"
        >
          <mat-label>{{ 'delivery-item.invoice-date' | translate }}</mat-label>
          <input
            matInput
            formControlName="invoiceDate"
            [matDatepicker]="invoiceDatePicker"
            placeholder="{{ 'delivery-item.invoice-date' | translate }}"
            [value]=""
            data-test="delivery-item__invoice-date"
          />
          <mat-datepicker-toggle matIconSuffix [for]="invoiceDatePicker"></mat-datepicker-toggle>
          <mat-datepicker touchUi #invoiceDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="flex__child--auto" *ngIf="isFinalSetup">
          <mat-label>{{ 'delivery-item.invoice-number' | translate }}</mat-label>
          <input
            matInput
            formControlName="externalInvoiceId"
            placeholder="{{ 'delivery-item.invoice-number' | translate }}"
            data-test="delivery-item__invoice-number"
          />
        </mat-form-field>

        <mat-form-field class="flex__child--auto" *ngIf="isFinalSetup">
          <mat-label>{{ 'delivery-item.vat-percentage' | translate }}</mat-label>
          <span matTextSuffix class="form-field-suffix">%</span>
          <mat-select
            [hideSingleSelectionIndicator]="true"
            formControlName="vatPercentage"
            data-test="delivery-item__vatPercentage"
          >
            <mat-option [value]="null"></mat-option>
            <mat-option *ngFor="let vatPercentage of vatPercentages" [value]="vatPercentage">
              {{ vatPercentage }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="flex--column">
        <div class="mat-button-row spacing--margin-top">
          <button
            type="submit"
            [disabled]="saveBtnDisabled"
            mat-flat-button
            color="primary"
            data-test="delivery-item__button-save"
          >
            {{ 'save' | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</agr-page-detail>
